import React from "react";
import styles from "./select-theme.module.scss";
import MultiSelectDropdown from "../multiselect-dropdown/multiselect-dropdown";
import { useIsMobile } from "../../hooks/mobile.js";

const THEME_ICON_SIZE = 48;

export default function SelectTheme(props) {
    const { themes, subThemeFilterState, themeFilterState, handleSubThemeFilter, handleThemeFilter } = props;

    const isMobile = useIsMobile();

    const options = themes.map(t => {
        return {
            ...t,
            children: t.children.map(c => {
                return {
                    value: c.id,
                    label: c.value,
                };
            }),
        };
    });

    const checkThemeFilterState = themeSlug => {
        return themeFilterState.some(d => d.value === themeSlug);
    };

    const checkThemeDisplayState = themeSlug => {
        return themeFilterState.length > 0 ? themeFilterState.some(d => d.value === themeSlug) : true;
    };

    return (
        <div className={styles.selectThemeContainer}>
            {!isMobile && (
                <div className={styles.selectThemeIcons}>
                    {themes.map(t => (
                        <div className={styles.selectThemeIcon} key={t.slug}>
                            <img
                                src={"data:image/svg+xml," + encodeURIComponent(t.icon)}
                                alt={t.theme}
                                className={styles.themeIconImage}
                                style={{
                                    height: isMobile ? THEME_ICON_SIZE * 0.5 : THEME_ICON_SIZE,
                                    width: "auto",
                                }}
                                width="auto"
                                height={isMobile ? THEME_ICON_SIZE * 0.5 : THEME_ICON_SIZE}
                                aria-hidden="true"
                            />
                        </div>
                    ))}
                </div>
            )}
            <div className={styles.selectTheme}>
                {options.map((o, i) => (
                    <div
                        className={styles.selectThemeItem}
                        key={o.slug}
                        data-theme={o.theme}
                        data-active={checkThemeDisplayState(o.slug) ? "active" : "inactive"}
                    >
                        <input
                            name={o.slug}
                            type="checkbox"
                            checked={checkThemeFilterState(o.slug)}
                            onChange={handleThemeFilter}
                            className={styles.themeCheck}
                            aria-label={`Turn the theme ${o.theme} ${checkThemeFilterState(o.slug) ? "off" : "on"}`}
                        />
                        <div className={styles.selectThemeDropdown}>
                            <MultiSelectDropdown
                                theme={o}
                                options={o.children}
                                placeholder={o.short}
                                onChange={handleSubThemeFilter}
                                values={subThemeFilterState}
                                themeFilterState={themeFilterState}
                                checkThemeFilterState={checkThemeFilterState}
                            />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
